export const namePattern = /^[A-Za-z' -]*$/;
export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phonePattern = /^\d{3}-\d{3}-\d{4}$/;
export const addressPattern = /^[a-zA-Z0-9' -]+$/;
